var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BeeModelManager } from "../../beeorm/BeeModelManager";
import { BookModel, CourseModel, CourseTimespanModel, } from "../../models/BookModel";
import { AppointmentModel } from "../../models/BookModel/Appointments/AppointmentModel";
import { OutgoingMessageModel } from "../../models/BookModel/OutgoingMessages/OutgoingMessageModel";
import { EntitiesEnum } from "../../store/store";
import { BillModel } from "./BillModel";
import { CourseParticipantModel } from "./CourseParticipantModel";
import { PaymentModel } from "./PaymentModel";
var BookModelManager = /** @class */ (function (_super) {
    __extends(BookModelManager, _super);
    function BookModelManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTypedModels = function (name) {
            return _this.getCollection(name)
                .all();
        };
        return _this;
    }
    Object.defineProperty(BookModelManager.prototype, "bookings", {
        get: function () {
            return this.getTypedModels(EntitiesEnum.COURSE_PARTICIPANTS)
                .map(function (model) { return model.prepareBookingsRow("user_entity.bookings"); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookModelManager.prototype, "bills", {
        get: function () {
            return this.getTypedModels(EntitiesEnum.BILLS).map(function (model) { return model.prepareBillRow(); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookModelManager.prototype, "payments", {
        get: function () {
            return this.getTypedModels(EntitiesEnum.PAYMENTS).map(function (model) { return (model).preparePaymentRow(); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BookModelManager.prototype, "messages", {
        get: function () {
            return this.getTypedModels(EntitiesEnum.OUTGOING_MESSAGES);
        },
        enumerable: false,
        configurable: true
    });
    return BookModelManager;
}(BeeModelManager));
export { BookModelManager };
export var getAuthEntityManager = function (entities, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var modelTypes = (_a = {},
        _a[EntitiesEnum.COURSE_TIMESPANS] = CourseTimespanModel,
        _a[EntitiesEnum.COURSES] = CourseModel,
        _a[EntitiesEnum.TAGS] = BookModel,
        _a[EntitiesEnum.PLACES] = BookModel,
        _a[EntitiesEnum.OUTGOING_MESSAGES] = OutgoingMessageModel,
        _a[EntitiesEnum.SELECT_OPTIONS] = BookModel,
        _a[EntitiesEnum.COURSE_APPOINTMENTS] = AppointmentModel,
        _a[EntitiesEnum.COURSE_PARTICIPANTS] = CourseParticipantModel,
        _a[EntitiesEnum.PAYMENTS] = PaymentModel,
        _a[EntitiesEnum.BILLS] = BillModel,
        _a[EntitiesEnum.PERSONAL_DATA] = BookModel,
        _a);
    return new BookModelManager(modelTypes, entities, options);
};
